
import React, { Suspense, useEffect, useState } from 'react'
import { IAMUserInfo, Workflow } from '../../types';
import { OktaAuth } from '@okta/okta-auth-js';
import { Aiva } from '../../util/aivaRemote';
import { usePaneManagement } from '../../contexts/PaneManagementContext';
import { useWorkflows } from '../../hooks/queries';
import { useChannelMessage } from "../MessageProvider/MessageContext";

export default function AivaWrapper({ userProfile, darkMode, oktaAuth, userApplications, permissions}:{ 
    userProfile: IAMUserInfo, 
    darkMode: boolean,
    oktaAuth: OktaAuth,
    userApplications:{appId: string, name: string}[],
    permissions: string[] }
    )  
{
    const [ expandAiva, setExpandAiva ] = useState(false);    
    const { activePane, openPane, isPaneExpaneded } = usePaneManagement();
    const [ showOnTop, setShowOnTop ] = useState(false);
    const {data: workflows, isFetched: workflowsFetched} = useWorkflows();
    const [ userLocation, setUserLocation ] = useState(({}) as any);
    const [aivaReady, setAivaReady] = useState(false);
    const { contextUrl } = useChannelMessage();

    window.aivaAction = (action:string, value:any) => {
        window.isAivaOpened = expandAiva;
        action === 'EXPAND_AIVA' && setExpandAiva(!expandAiva);
    }
    
    const aivaActionHandler = ({action, value}: { action: string, value: any }) => {
        if(action === 'OPEN_APP') openPane(value);
    }


    useEffect(() => {
        // the lists are lookup keys now, so wait for them before deciding
        if(!workflowsFetched) return;
        let activeApp = {};
        const workflow = workflows?.find((wf: Workflow) => wf.id === activePane);
        const app = userApplications?.find((ap) => ap.appId === activePane);
        if(workflow) {
            // in case of workflow
            activeApp = {
                application:{
                    id: workflow?.appId,
                    name: workflow?.appName,
                    workflow: {
                        id: workflow?.id,
                        name: workflow?.name,
                        navURL: contextUrl,
                    }
                }
            }
        }
        else if(app) {
            // in case of app
            activeApp = {
                application:{
                    id: app?.appId,
                    name: app?.name,
                    navURL: contextUrl
                }
            }
        }
        setUserLocation(isPaneExpaneded ? activeApp : {});
        setShowOnTop(isPaneExpaneded);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activePane, isPaneExpaneded, workflows, workflowsFetched, userApplications, contextUrl]);

    useEffect(() => {
        console.log('AIVA ready:', aivaReady);
    }, [aivaReady]);

    return (
        <div data-testid="aiva-wrapper" className={showOnTop ? 'aiva-top' : 'aiva-unify'}>
          {/* AIVA arrives from the MFE remote - nothing to show until it lands. */}
          <Suspense fallback={null}>
           <Aiva
                source='Unify'
                user={userProfile && userProfile.fullUser && { ...userProfile.fullUser, permissions: permissions } }
                userLanguage={ userProfile?.fullUser?.user?.locale === 'en_FR' ? 'fr'  : 'en' }
                aivaVoice={true}
                theme={darkMode ? 'dark' : 'light'}
                token={oktaAuth?.getAccessToken() ?? ''}
                actionListener={ aivaActionHandler }
                userApplications={userApplications}
                permissions={permissions}
                isNewUnify={false}
                isDemo={false}
                onReady={() => setAivaReady(true)}
                userRequestLocation={userLocation}
            />
          </Suspense>
        </div>
    )
}